// Purpose: Build Power Up detail URLs and resolve current, legacy ID, or retained alias links.
// Features: Family-specific paths and fields with document-ID fallbacks.
// Dependencies: Firebase Firestore client SDK.
// Important behavior: Aliases resolve to their original record; IDs remain operational identities.

import { collection, doc, getDoc, getDocs, limit, query, where } from "firebase/firestore";

export const POWERUP_URL_FAMILIES = {
  sponsor: { collection: "sponsors", field: "sponsorSlug", claims: "sponsor_slug_claims", path: "sponsors" },
  vendor: { collection: "vendors", field: "vendorSlug", claims: "vendor_slug_claims", path: "vendors" },
  product: { collection: "store_items", field: "productSlug", claims: "product_slug_claims", path: "store" },
  auction: { collection: "auctionItems", field: "auctionSlug", claims: "auction_slug_claims", path: "auction" },
};
export const isValidPowerupSlug = (value) => typeof value === "string" && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value) && value.length <= 100;
export const getPowerupPath = (eventslug, family, entity) => {
  const config = POWERUP_URL_FAMILIES[family];
  return `/${eventslug}/${config.path}/${encodeURIComponent(entity?.[config.field] || entity?.id || "")}`;
};
export async function resolvePowerupSnapshot(db, eventId, family, identifier) {
  const config = POWERUP_URL_FAMILIES[family];
  if (!config) return null;
  const legacy = await getDoc(doc(db, "events", eventId, config.collection, identifier));
  if (legacy.exists()) return legacy;
  const matches = await getDocs(query(collection(db, "events", eventId, config.collection), where(config.field, "==", identifier), limit(1)));
  if (matches.docs[0]) return matches.docs[0];
  if (!isValidPowerupSlug(identifier)) return null;
  const alias = await getDoc(doc(db, "events", eventId, config.claims, identifier));
  const entityId = alias.exists() ? alias.data().entityId : "";
  return typeof entityId === "string" && entityId && !entityId.includes("/")
    ? (await getDoc(doc(db, "events", eventId, config.collection, entityId)))
    : null;
}
